import {ActionsTransform} from "./ActionsTransform";
import {assistantsTransform} from "../assistants/AssistantsTransform";

import {
  InformationExtractorListModel,
  InformationExtractorRecordModel,
  InformationExtractorCreateModel,
  InformationExtractorUpdateModel,
} from "@/api/models";
import {InformationExtractorAction, PaginatedResponse} from "@/api/services";
import {BaseAction} from "@/types/api";

export class ActionInformationExtractorTransform extends ActionsTransform<
  InformationExtractorRecordModel,
  InformationExtractorCreateModel,
  InformationExtractorUpdateModel
> {
  public makeRecordModel(
    dto: InformationExtractorAction & BaseAction,
  ): InformationExtractorRecordModel {
    const model: InformationExtractorRecordModel = {
      ...dto,
      title: dto.name,
      description: "",
      question: dto.question,
      assistants: dto.assistants.map(assistant =>
        assistantsTransform.makeEvenCompactModel(assistant),
      ),
    };

    return model;
  }

  public makeListModel(dto: PaginatedResponse): InformationExtractorListModel {
    const model: InformationExtractorListModel = {
      records: dto.items.map(item =>
        this.makeRecordModel(item as InformationExtractorAction & BaseAction),
      ),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }

  public makeCreateDto(
    model: InformationExtractorCreateModel,
  ): InformationExtractorAction {
    const dto: InformationExtractorAction = {
      type: "info",
      workspace_id: model.workspaceId,
      assistants: [],
      question: model.question,
      name: model.name,
    };

    return dto;
  }

  public makeUpdateDto(
    model: InformationExtractorUpdateModel,
  ): InformationExtractorAction {
    const dto: InformationExtractorAction = {
      type: "info",
      workspace_id: model.workspaceId,
      question: model.question,
      name: model.name,
    };

    return dto;
  }
}

export const actionInformationExtractorTransform =
  new ActionInformationExtractorTransform();
